export const defaults = {
    podcastType: 'episodic',
    language: 'en-us',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'GMT',
};

export const descriptionCharactersLimit = 4000;

export const artworkAllowedTypes = {
    '.jpg': 'image/jpeg',
    '.jpeg': 'image/jpeg',
    '.png': 'image/png',
};

export const podcastTypes = [
    {
        value: 'episodic',
        label: 'Episodic',
    },
    {
        value: 'serial',
        label: 'Serial',
    },
];

export const languages = [
    { value: 'af', label: 'Afrikaans' },
    { value: 'ak', label: 'Akan' },
    { value: 'sq', label: 'Albanian' },
    { value: 'ar', label: 'Arabic' },
    { value: 'hy', label: 'Armenian' },
    { value: 'az', label: 'Azerbaijani' },
    { value: 'bm', label: 'Bambara' },
    { value: 'eu', label: 'Basque' },
    { value: 'be', label: 'Belarusian' },
    { value: 'bn', label: 'Bengali' },
    { value: 'nb', label: 'Bokmål, Norwegian' },
    { value: 'bs', label: 'Bosnian' },
    { value: 'br', label: 'Breton' },
    { value: 'bg', label: 'Bulgarian' },
    { value: 'my', label: 'Burmese' },
    { value: 'ca', label: 'Catalan' },
    { value: 'km', label: 'Central Khmer' },
    { value: 'ce', label: 'Chechen' },
    { value: 'zh-cn', label: 'Chinese (Simplified)' },
    { value: 'zh-tw', label: 'Chinese (Traditional)' },
    { value: 'kw', label: 'Cornish' },
    { value: 'hr', label: 'Croatian' },
    { value: 'cs', label: 'Czech' },
    { value: 'da', label: 'Danish' },
    { value: 'nl', label: 'Dutch' },
    { value: 'nl-be', label: 'Dutch (Belgium)' },
    { value: 'nl-nl', label: 'Dutch (Netherlands)' },
    { value: 'dz', label: 'Dzongkha' },
    { value: 'en', label: 'English' },
    { value: 'en-au', label: 'English (Australia)' },
    { value: 'en-bz', label: 'English (Belize)' },
    { value: 'en-ca', label: 'English (Canada)' },
    { value: 'en-ie', label: 'English (Ireland)' },
    { value: 'en-jm', label: 'English (Jamaica)' },
    { value: 'en-nz', label: 'English (New Zealand)' },
    { value: 'en-ph', label: 'English (Phillipines)' },
    { value: 'en-za', label: 'English (South Africa)' },
    { value: 'en-tt', label: 'English (Trinidad)' },
    { value: 'en-gb', label: 'English (United Kingdom)' },
    { value: 'en-us', label: 'English (United States)' },
    { value: 'en-zw', label: 'English (Zimbabwe)' },
    { value: 'eo', label: 'Esperanto' },
    { value: 'et', label: 'Estonian' },
    { value: 'ee', label: 'Ewe' },
    { value: 'fo', label: 'Faeroese' },
    { value: 'fil', label: 'Filipino' },
    { value: 'fi', label: 'Finnish' },
    { value: 'fr', label: 'French' },
    { value: 'fr-be', label: 'French (Belgium)' },
    { value: 'fr-ca', label: 'French (Canada)' },
    { value: 'fr-fr', label: 'French (France)' },
    { value: 'fr-lu', label: 'French (Luxembourg)' },
    { value: 'fr-mc', label: 'French (Monaco)' },
    { value: 'fr-ch', label: 'French (Switzerland)' },
    { value: 'ff', label: 'Fulah' },
    { value: 'gd', label: 'Gaelic' },
    { value: 'gl', label: 'Galician' },
    { value: 'lg', label: 'Ganda' },
    { value: 'ka', label: 'Georgian' },
    { value: 'de', label: 'German' },
    { value: 'de-at', label: 'German (Austria)' },
    { value: 'de-de', label: 'German (Germany)' },
    { value: 'de-li', label: 'German (Liechtenstein)' },
    { value: 'de-lu', label: 'German (Luxembourg)' },
    { value: 'de-ch', label: 'German (Switzerland)' },
    { value: 'el', label: 'Greek' },
    { value: 'gu', label: 'Gujarati' },
    { value: 'ha', label: 'Hausa' },
    { value: 'haw', label: 'Hawaiian' },
    { value: 'he', label: 'Hebrew' },
    { value: 'hi', label: 'Hindi' },
    { value: 'hu', label: 'Hungarian' },
    { value: 'is', label: 'Icelandic' },
    { value: 'ig', label: 'Igbo' },
    { value: 'in', label: 'Indonesian' },
    { value: 'iu', label: 'Inuktitut' },
    { value: 'ga', label: 'Irish' },
    { value: 'it', label: 'Italian' },
    { value: 'it-it', label: 'Italian (Italy)' },
    { value: 'it-ch', label: 'Italian (Switzerland)' },
    { value: 'ja', label: 'Japanese' },
    { value: 'kl', label: 'Kalaallisut' },
    { value: 'kn', label: 'Kannada' },
    { value: 'ks', label: 'Kashmiri' },
    { value: 'kk', label: 'Kazakh' },
    { value: 'ki', label: 'Kikuyu' },
    { value: 'rw', label: 'Kinyarwanda' },
    { value: 'ky', label: 'Kirghiz' },
    { value: 'ko', label: 'Korean' },
    { value: 'lo', label: 'Lao' },
    { value: 'lv', label: 'Latvian' },
    { value: 'ln', label: 'Lingala' },
    { value: 'lt', label: 'Lithuanian' },
    { value: 'lu', label: 'Luba-Katanga' },
    { value: 'lb', label: 'Luxembourgish' },
    { value: 'mk', label: 'Macedonian' },
    { value: 'mg', label: 'Malagasy' },
    { value: 'ms', label: 'Malay' },
    { value: 'ml', label: 'Malayalam' },
    { value: 'mt', label: 'Maltese' },
    { value: 'gv', label: 'Manx' },
    { value: 'mr', label: 'Marathi' },
    { value: 'mn', label: 'Mongolian' },
    { value: 'nd', label: 'Ndebele, North' },
    { value: 'nr', label: 'Ndebele, South' },
    { value: 'ne', label: 'Nepali' },
    { value: 'se', label: 'Northern Sami' },
    { value: 'no', label: 'Norwegian' },
    { value: 'nn', label: 'Norwegian Nynorsk' },
    { value: 'om', label: 'Oromo' },
    { value: 'os', label: 'Ossetian' },
    { value: 'pa', label: 'Panjabi' },
    { value: 'fa', label: 'Persian' },
    { value: 'pl', label: 'Polish' },
    { value: 'pt', label: 'Portuguese' },
    { value: 'pt-br', label: 'Portuguese (Brazil)' },
    { value: 'pt-pt', label: 'Portuguese (Portugal)' },
    { value: 'qu', label: 'Quechua' },
    { value: 'ro', label: 'Romanian' },
    { value: 'ro-mo', label: 'Romanian (Moldova)' },
    { value: 'ro-ro', label: 'Romanian (Romania)' },
    { value: 'rm', label: 'Romansh' },
    { value: 'rn', label: 'Rundi' },
    { value: 'ru', label: 'Russian' },
    { value: 'ru-mo', label: 'Russian (Moldova)' },
    { value: 'ru-ru', label: 'Russian (Russia)' },
    { value: 'sg', label: 'Sango' },
    { value: 'sr', label: 'Serbian' },
    { value: 'sn', label: 'Shona' },
    { value: 'ii', label: 'Sichuan Yi' },
    { value: 'si', label: 'Sinhala' },
    { value: 'sk', label: 'Slovak' },
    { value: 'sl', label: 'Slovenian' },
    { value: 'so', label: 'Somali' },
    { value: 'es', label: 'Spanish' },
    { value: 'es-ar', label: 'Spanish (Argentina)' },
    { value: 'es-bo', label: 'Spanish (Bolivia)' },
    { value: 'es-cl', label: 'Spanish (Chile)' },
    { value: 'es-co', label: 'Spanish (Colombia)' },
    { value: 'es-cr', label: 'Spanish (Costa Rica)' },
    { value: 'es-do', label: 'Spanish (Dominican Republic)' },
    { value: 'es-ec', label: 'Spanish (Ecuador)' },
    { value: 'es-sv', label: 'Spanish (El Salvador)' },
    { value: 'es-gt', label: 'Spanish (Guatemala)' },
    { value: 'es-hn', label: 'Spanish (Honduras)' },
    { value: 'es-mx', label: 'Spanish (Mexico)' },
    { value: 'es-ni', label: 'Spanish (Nicaragua)' },
    { value: 'es-pa', label: 'Spanish (Panama)' },
    { value: 'es-py', label: 'Spanish (Paraguay)' },
    { value: 'es-pe', label: 'Spanish (Peru)' },
    { value: 'es-pr', label: 'Spanish (Puerto Rico)' },
    { value: 'es-es', label: 'Spanish (Spain)' },
    { value: 'es-uy', label: 'Spanish (Uruguay)' },
    { value: 'es-ve', label: 'Spanish (Venezuela)' },
    { value: 'sw', label: 'Swahili' },
    { value: 'sv', label: 'Swedish' },
    { value: 'sv-fi', label: 'Swedish (Finland)' },
    { value: 'sv-se', label: 'Swedish (Sweden)' },
    { value: 'tl', label: 'Tagalog' },
    { value: 'tg', label: 'Tajik' },
    { value: 'ta', label: 'Tamil' },
    { value: 'tt', label: 'Tatar' },
    { value: 'te', label: 'Telugu' },
    { value: 'th', label: 'Thai' },
    { value: 'bo', label: 'Tibetan' },
    { value: 'ti', label: 'Tigrinya' },
    { value: 'to', label: 'Tonga (Tonga Islands)' },
    { value: 'tr', label: 'Turkish' },
    { value: 'tk', label: 'Turkmen' },
    { value: 'ug', label: 'Uighur' },
    { value: 'uk', label: 'Ukrainian' },
    { value: 'ur', label: 'Urdu' },
    { value: 'uz', label: 'Uzbek' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'cy', label: 'Welsh' },
    { value: 'wo', label: 'Wolof' },
    { value: 'yi', label: 'Yiddish' },
    { value: 'yo', label: 'Yoruba' },
    { value: 'zu', label: 'Zulu' },
];
